export default "__VITE_ASSET__C0E66zAM__"